import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "onedesk-multiselect-counter",
    "data-testid": "one-desk-multi-select-label"
};
const _hoisted_2 = { class: "onedesk-multiselect-show-only-selected" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("label", { for: "onlySelected" }, "Show only selected", -1);
import { computed, ref, useSlots, watch } from "vue";
import MultiSelect from "primevue/multiselect";
import Checkbox from "primevue/checkbox";
export default /*#__PURE__*/ _defineComponent({
    __name: 'OneDeskMultiSelect',
    props: {
        lineraLabel: { type: Boolean, default: true },
        options: { default: () => [] },
        modelValue: { default: [] },
        optionLabel: { default: "label" },
        optionValue: { default: "value" },
        filter: { type: Boolean, default: false },
        fullWidth: { type: Boolean, default: false },
        showCounter: { type: Boolean, default: false },
        placeholder: { default: "" },
        loading: { type: Boolean, default: false }
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const slots = useSlots();
        const labelClassName = computed(() => "onedesk-dropdown-label " + (props.lineraLabel ? "onedesk-dropdown-label-linear" : ""));
        const oneDeskDropdownClassName = computed(() => "onedesk-dropdown onedesk-input" + (props.fullWidth ? " onedesk-dropdown-full-width" : ""));
        const hasLabelSlot = computed(() => !!slots.label);
        const selected = ref(props.modelValue);
        const showOnlySelected = ref(false);
        const optionsSelected = computed(() => {
            if (selected.value && selected.value.length == 0)
                return [];
            else {
                return selected.value?.map((element) => props.options.find((option) => option[props.optionValue] == element));
            }
        });
        watch(() => props.modelValue, (value) => {
            selected.value = value;
        });
        watch(selected, (currentValue) => {
            emit("update:modelValue", currentValue);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(oneDeskDropdownClassName.value)
            }, [
                (hasLabelSlot.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(labelClassName.value)
                    }, [
                        _renderSlot(_ctx.$slots, "label")
                    ], 2))
                    : _createCommentVNode("", true),
                _createVNode(_unref(MultiSelect), {
                    "data-testid": "one-desk-multi-select",
                    modelValue: selected.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((selected).value = $event)),
                    options: showOnlySelected.value ? optionsSelected.value : _ctx.options,
                    "option-label": props.optionLabel,
                    "option-value": props.optionValue,
                    filter: props.filter,
                    display: "chip",
                    class: "one-desk-multiselect",
                    placeholder: props.loading ? 'loading ... ' : props.placeholder,
                    loading: props.loading
                }, {
                    header: _withCtx((slotProps) => [
                        (props.showCounter)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString((slotProps.value ? slotProps.value.length : 0) + " elements selected"), 1))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_2, [
                            _createVNode(_unref(Checkbox), {
                                modelValue: showOnlySelected.value,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((showOnlySelected).value = $event)),
                                binary: true,
                                name: "onlySelected"
                            }, null, 8, ["modelValue"]),
                            _hoisted_3
                        ])
                    ]),
                    _: 1
                }, 8, ["modelValue", "options", "option-label", "option-value", "filter", "placeholder", "loading"])
            ], 2));
        };
    }
});
